import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function PrivateRoute({ children }) {
  const { currentUser, loading } = React.useContext(AuthContext);

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  return currentUser ? children : <Navigate to="/login" />;
}

export default PrivateRoute; 